import { defineModelEffect } from '@/app/libs/I';
import { storeModel } from '@/app/modules/store/storeModel';
import { useBitrixStore } from '@/shared/store/useBitrixStore';

/**
 * @deprecated legacy
 */
function getStore(): any {
  return {
    bitrix: useBitrixStore(),
  };
}

/**
 * @deprecated legacy
 */
export const storeGetter = defineModelEffect(storeModel, async model => {
  const store = getStore();
  const pathParts = model.path.split('/');

  return storeModel(model, {
    value: store[pathParts[0]]?.[pathParts[1]],
  }).value;
});

/**
 * @deprecated legacy
 */
export const storeSetter = defineModelEffect(storeModel, async model => {
  const store = getStore();
  const pathParts = model.path.split('/');

  store[pathParts[0]]?.[pathParts[1]]?.(model.value);

  return model;
});
